/** Lets PreviewNodes (and other callers) run the same PDF pipeline as module ZIP export. */
let documentPdfExporter = null;

export function registerDocumentPdfExporter(fn) {
  documentPdfExporter = typeof fn === "function" ? fn : null;
}

export async function runDocumentPdfExport(options) {
  if (!documentPdfExporter) {
    throw new Error(
      "Document PDF exporter is not ready. ExportFormatPopup (PDF engine) must be mounted.",
    );
  }
  return documentPdfExporter(options);
}
